





















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { UpdateCurrentUserPwd, ResetPassword } from '../api/enterprise/index';

@Component({
  name: 'EditPwd',
})
export default class EditPwd extends Vue {
  editType = 'edit';
  userSn = '';
  visableSync = false;
  $show(type: string, userSn: string) {
    if (type) {
      this.editType = type;
      this.userSn = userSn;
    }
    this.visableSync = true;
  }

  close() {
    this.visableSync = false;
  }

  updateFormVisable = false;
  updateForm = {
    oldPassword: '',
    confirmPasssword: '',
    password: '',
  };

  updateFormRules = {
    oldPassword: [
      {
        required: true,
        message: '请输入旧密码',
        trigger: 'blur',
      },
    ],
    password: [
      {
        required: true,
        message: '请输入新密码',
        trigger: 'blur',
      },
    ],
    confirmPasssword: [
      {
        required: true,
        message: '请输入密码',
        trigger: 'blur',
      },
    ],
    department: [
      {
        required: true,
        message: '请输入部门',
        trigger: 'blur',
      },
    ],
  };
  async submitForm() {
    if (this.editType == 'reset') {
      ResetPassword({
        userSn: this.userSn,
        password: this.updateForm.password,
      }).then(() => {
        this.$message.success('修改成功');
        this.visableSync = false;
      });
      return;
    }
    if (this.updateForm.confirmPasssword != this.updateForm.password) {
      this.$message.error('密码不一致，请检查');
      return;
    }
    (this.$refs['updateFormRef'] as any).validate().then((res: any) => {
      if (res) {
        UpdateCurrentUserPwd(this.updateForm).then(() => {
          this.$message.success('修改成功');
          this.visableSync = false;
        });
      }
    });
  }
}
